import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Row, Container, Col } from "react-bootstrap";
import { Button, IconButton, Dialog, DialogContent } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import AccessibiltyPolicy from '../Disclosure/AccessibilityPolicy';
import PrivacyPolicy from '../Disclosure/PrivacyPolicy';
import TermsAndConditions from '../Disclosure/TermsAndConditions';
import StateDisclosure from '../Disclosure/StateDisclosure';
import ContactUs from '../Contact/ContactUs';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY, SESSION_STORAGE_AFLAC_QUOTE } from '../../sessionStorage';
import CustomerSupportPhone from '../Account/CustomerSupportPhone';
import { ALASKA, ARIZONA, ARKANSAS, CALIFORNIA, COLORADO, CONNECTICUT, DISTRICT_OF_COLUMBIA, FLORIDA, GEORGIA, HAWAII, IDAHO, ILLINOIS, INDIANA, IOWA, KANSAS, KENTUCKY, LOUISIANA, MAINE, MARYLAND, MASSACHUSETTS, MICHIGAN, NEWHAMPSHIRE, NEWMEXICO, OHIO, PENNSYLVANIA, TEXAS, UTAH, VERMONT, VIRGIN_ISLANDS, WEST_VIRGINIA } from '../Helpers/Constants/States';
import { getStateWiseInformation, getStateWiseSubText } from './InfoTextForAflac';
import './Footer.scss';

const links = {
  Terms: "TermsAndConditions",
  Security: "SecurityAndPrivacyPolicy",
  Accessibilty: "AccessibiltyPolicy",
  Contact: "ContactUs",
  StateLicense: "StateLicenseDisclosure",
}

const sentryBuildNumber = process.env.REACT_APP_SENTRY_BUILD_NUMBER;

export default function Footer() {
  const year = new Date().getFullYear();
  const aflacSupplementalProduct = document.location.pathname.toLowerCase().indexOf('supplemental') > -1;


  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [accountId, setAccountId] = useState('');
  const [disclaimer, setDisclaimer] = useState('');
  const [disclaimerBelow, setDisclaimerBelow] = useState(false);
  const [renderComponent, setRenderComponent] = useState(null);
  const [enableDefaultDisclaimer, setEnableDefaultDisclaimer] = useState(true);

  const location = useLocation();
  const isAflacLandingPage = document.location.pathname.toLowerCase().includes('landing/hospital');
  const aflacHospitalConfinementProduct = document.location.pathname.toLowerCase().includes('landing/hospital') || document.location.pathname.toLowerCase().includes('hospital-confinement');
  const [isRouteChange, setIsRouteChange] = useState(aflacHospitalConfinementProduct);

  useEffect(() => {
    setIsRouteChange(aflacHospitalConfinementProduct);
  }, [location]);

  useEffect(() => {
    var accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
    if (accountObj && accountObj.account && accountObj.account.accountId) {
      setAccountId(accountObj.account.accountId);
      setDisclaimer(accountObj.account.disclaimerHtml);
      setDisclaimerBelow(accountObj.account.customDisclaimerBelow);
      setEnableDefaultDisclaimer(accountObj.account.enableDefaultDisclaimer);
    }
  }, []);

  const onButtonClick = (linkName) => {
    if (linkName === links.Terms) {
      setRenderComponent(<TermsAndConditions></TermsAndConditions>);
    } else if (linkName === links.Security) {
      setRenderComponent(<PrivacyPolicy></PrivacyPolicy>);
    } else if (linkName === links.AccessibiltyPolicy) {
      setRenderComponent(<AccessibiltyPolicy></AccessibiltyPolicy>);
    } else if (linkName === links.StateLicense) {
      setRenderComponent(<StateDisclosure></StateDisclosure>);
    } else if (linkName === links.Contact) {
      setRenderComponent(<ContactUs></ContactUs>);
    }
    setInfoDialogOpen(true);
  }

  const getDisclaimers = () => {
    return (
      <small>
        {disclaimerBelow &&
          <span>
            {aflacSupplementalProduct && aflacSupplementalProductDisclaimer()}
            {isRouteChange && aflacHospitalConfinementProductDisclaimer()}
            {enableDefaultDisclaimer && covrDisclaimer()}
            <br />
          </span>
        }
        {disclaimer &&
          <span>
            <span dangerouslySetInnerHTML={{ __html: disclaimer }} />
            <br />
          </span>
        }
        {!disclaimerBelow &&
          <span>
            {aflacSupplementalProduct && aflacSupplementalProductDisclaimer()}
            {isRouteChange && aflacHospitalConfinementProductDisclaimer()}
            {enableDefaultDisclaimer && covrDisclaimer()}
          </span>
        }
      </small>
    )
  }

  const aflacSupplementalProductDisclaimer = () => {
    return (
      <span>
        <span>IMPORTANT NOTICES APPLICABLE TO AFLAC:</span><br />
        <span>This is a brief product overview only. Coverage may not be available in all states. Policies and riders may also contain a waiting period. Refer to the exact policies and riders for benefit details, definitions, limitations and exclusions. For availability and costs, please please call {CustomerSupportPhone()}.</span><br />
        <span>Aflac coverage is underwritten by Aflac. In New York, coverage is underwritten by Aflac New York.</span><br />
        <span>Aflac | WWHQ | 1932 Wynnton Road | Columbus, GA 31999</span><br />
        <Row>
          <Col className="text-end">Z2100735A</Col>
          <Col className="text-start ps-0"> EXP 9/22</Col>
        </Row>
      </span >
    )
  }

  const covrDisclaimer = () => {
    return (
      <span>Insurance products are sold through Covr Financial Technologies Inc (“Covr”). Covr sells insurance as an agent or broker by contractual agreements with its insurance carrier providers.
        Covr is licensed in the following states: Delaware (3000067942), Idaho (607086), California (0L77229). All other state license numbers are available on our <a className='footer-disclosure-link' onClick={() => onButtonClick(links.StateLicense)}>State License Disclosure Page</a>.
      </span>
    )
  }

  const aflacHospitalConfinementProductDisclaimer = () => {

    const dataFromSession = getSessionStorageItem(SESSION_STORAGE_AFLAC_QUOTE);
    const basicInfoState = dataFromSession && dataFromSession.steps.basicInfo.state;
    const stateListForFormNumber = [ARKANSAS, ARIZONA, ALASKA, CALIFORNIA, COLORADO, CONNECTICUT, DISTRICT_OF_COLUMBIA, FLORIDA, GEORGIA, HAWAII, IDAHO, ILLINOIS, INDIANA, IOWA, KANSAS, KENTUCKY, LOUISIANA, MAINE, MARYLAND, MICHIGAN, NEWHAMPSHIRE, OHIO, PENNSYLVANIA, TEXAS, UTAH, VERMONT, VIRGIN_ISLANDS, WEST_VIRGINIA,NEWMEXICO, MASSACHUSETTS]
    const state = dataFromSession && dataFromSession.currentStep !== 1 ? basicInfoState : "";
    const subTextObj = getStateWiseSubText(state);

    return (
      <React.Fragment>
        <Row>
          <Col className="text-center aflacFont">IMPORTANT NOTICES APPLICABLE TO AFLAC:</Col>
        </Row>
        <Row className="pt-3 aflacFont">
          <Col>
            {isAflacLandingPage ? <span>
              *Hospital insurance is also known as indemnity insurance or supplemental only insurance in some states.<br /><br /> The information provided is a brief product overview only. Coverage may not be available in all states, including ID, NJ, NM and/or NY. In Arkansas, Policies B40100AR & B401HAR. In Delaware, Policies B40100DE & B4010HDE. In Idaho, Policies B40100ID & B4010HID. In New York, Policies NYB40100 & NYB4010H. In Oklahoma, Policies B40100OK & B4010HOK. In Oregon, Policies B40100OR & B4010HOR. In Pennsylvania, Policies B40100PA & B4010HPA. In Texas, Policies B40100TX & B4010HTX. In Virginia, Policies B40100VA & B4010HVA.Benefits/premium rates may vary based on the plan selected. Optional riders may be available at an additional cost. Policies and riders may also contain a waiting period. Refer to the exact policies and riders for benefit details, definitions, limitations and exclusions.
            </span>
              :
              getStateWiseInformation(state)}
          </Col>
        </Row>

        <Row className={`pt-3 ${subTextObj.largeFont ? 'aflac-font' : 'aflacFont'}`}>
          <Col>
            {isAflacLandingPage ? "Aflac coverage is underwritten by American Family Life Assurance Company of Columbus. In New York, Aflac coverage is underwritten by American Family Life Assurance Company of New York." : subTextObj.text}
          </Col>
        </Row>
        <Row className="pt-3 aflacFont"><Col>Aflac WWHQ | 1932 Wynnton Road | Columbus, GA 31999	</Col></Row>
        <Row className="pt-3 aflacFont justify-content-center">
          {
            dataFromSession && stateListForFormNumber.includes(basicInfoState) ?
              `Z2200218${basicInfoState}`
              :
              'Z2200218'
          }
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          {
              'EXP 03/25'
          }
        </Row>
      </React.Fragment>
    )
  }

  return (
    <footer className="footer py-3 flex-fill">
      <Container fluid>
        <Col lg={12} className="p-0">
          <Row className="justify-content-center">
            <Col lg={6} className='text-center flex-md-grow-0'>
              {getDisclaimers()}
            </Col>
          </Row>
          <Row className="justify-content-center my-4 links g-0">
            {[
              { text: "Terms & Conditions", link: links.Terms },
              { text: "Security & Privacy Policy", link: links.Security },
              { text: "Accessibility Policy", link: links.AccessibiltyPolicy },
              { text: "Contact Us", link: links.Contact }
            ].map(({ text, link }, index) => (
              <Col key={index} xs={12} sm className="d-flex align-items-center colSetting justify-content-center flex-fill">
                <Button variant="text" className='footer-button' onClick={() => onButtonClick(link)}>{text}</Button>
            </Col>
            ))}
            <Col xs={12} sm className="d-flex align-items-center colSetting justify-content-center flex-fill lastCol">
              <Row>
                <span>Account ID: {accountId}</span>
              </Row>
              <Row>
                <span>Version: {sentryBuildNumber}</span>
              </Row>
            </Col>
          </Row>
          <Row className="justify-content-center"><strong>Powered by</strong></Row>
          <Row className="justify-content-center">
            <img src={`${process.env.PUBLIC_URL}/logos/covr-logo.svg`} alt="Covr Logo" />
          </Row>
          <Row className="justify-content-center covr">Covr Financial Technologies</Row>
          <Row className="justify-content-center">Hartford. Boise. Colorado Springs.</Row>
          <Row className="justify-content-center">Copyright &copy; {year}</Row>
        </Col>

        <FooterModalPopup
          open={infoDialogOpen}
          onInfoDialogClosed={() => {
            setInfoDialogOpen(false);
          }}
          component={renderComponent}
        >
        </FooterModalPopup>

      </Container>
    </footer>
  )
}

function FooterModalPopup(props) {
  return (
    <Dialog open={props.open} onClose={props.onInfoDialogClosed} scroll="body">
      <DialogContent className="product-info-dialog-content">
        <IconButton
          className="product-info-close-button"
          aria-label="close"
          onClick={props.onInfoDialogClosed}
          size="large">
          <CloseIcon />
        </IconButton>
        {props.component}
      </DialogContent>
    </Dialog>
  );
}
